import { useQuery } from '@tanstack/react-query'
import { get } from '../api'
import { useAccount } from './useAccount'
import { useEffect, useMemo } from 'react'
import { selectIsRefreshBalance } from '../store/rushbSelectors'
import { useDispatch, useSelector } from 'react-redux'
import { setGemBalance, setIsRefreshBalance } from '../store/rushbSlice'
import { BaseURLS } from '../api/axios'

export interface GemBalance {
  gemBalance: number
  version: number
}

const useGemBalance = () => {
  const dispatch = useDispatch()
  const { isLogin } = useAccount()
  const isRefreshBalance = useSelector(selectIsRefreshBalance)
  const { data, isLoading, refetch } = useQuery<GemBalance>({
    queryKey: ['gemBalance', isLogin],
    queryFn: async () => {
      const res = await get('/v1/balance', {}, { baseURL: BaseURLS.rush })
      dispatch(setGemBalance(res.gemBalance))
      return res
    },
    enabled: isLogin,
    staleTime: 5000,
  })

  useEffect(() => {
    if (isRefreshBalance) {
      refetch()
      dispatch(setIsRefreshBalance(false))
    }
  }, [dispatch, isRefreshBalance])

  return {
    data,
    isLoading,
  }
}

export default useGemBalance
